/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";
import { parse } from "node-html-parser";
import { Tooltip, Typography, Paper, Dialog } from "@material-ui/core";
import Actions from "../../../../../fluid/Actions/ActionFactory";
import { CloudDownload, Fullscreen, FullscreenExit } from '@material-ui/icons'
import IconButton from '@material-ui/core/IconButton'
class HTMLViewer extends Component {
  state = {
    url: this.props.url,
    location: this.props.location,
    htmlContent: "",
    drl_url: this.props.drl_url,
    shouldUpdateImgSrc: false,
    download: false,
    ishighlightOn : false,
    open : false
  };

  componentDidMount = async () => {
    await this.setDefaults();
    await this.getFile();
  };

  componentWillReceiveProps = (nextProps) => {
    // if ( (this.state.location !== nextProps.location ) || ( this.state.location) ) {
    //   this.setState({ shouldUpdateImgSrc: false }, () => {
    //     this.parseHTML(this.state.htmlContent);
    //   })

    // } else if( this.state.url !== nextProps.url){
    //   this.getFile()
    // }

    if (this.state.url !== nextProps.url) {
      this.getFile();
    } else {
      this.setState({ shouldUpdateImgSrc: false }, () => {
        this.parseHTML(this.state.htmlContent);
      });
    }
  };

  setDefaults = () => {
    let { params } = this.props;
    //let ishighlightOn = params.find((element) => element.key === 'highlight').value.boolean;
    let download = false;
    if( params.find((element) => element.key === 'download') ) {
        download  = params.find((element) => element.key === 'download').value.boolean;
    }

    this.setState({
      url: this.props.url,
      location: this.props.location,
      download : download,
      ishighlightOn : false
    });
  };

  parseHTML = (htmlContent) => {
    try {
      let root = parse(htmlContent, { style: true, script: true, pre: true });
      let script = this.getScript("'" + this.props.location + "'");
      let location = "#" + this.props.location;
      let { shouldUpdateImgSrc, drl_url } = this.state;

      // if (shouldUpdateImgSrc === true) {
      //   root.querySelectorAll("img").map((imgElement) => {
      //     let imgURL = imgElement.getAttribute("src");
      //     let drlAppendedImageURL = drl_url + "/" + imgURL;
      //     imgElement.setAttribute("src", drlAppendedImageURL);
      //   });
      // }

      if(this.props.ishighlightOn){
        root.querySelector(location).setAttribute("style", "background: rgba(0, 253,142, 0.5)");
      }
      root.querySelector(location).setAttribute("style", "background: rgba(0, 253,142, 0.5)");
      root.querySelector("body").appendChild(script);
      root.querySelector("img");
      root.toString();
      this.setState({
        htmlContent: root,
        shouldUpdateImgSrc: false,
      });
    } catch (err) {
      console.log("error while parsing html", err);
    }
  };

  getScript = (location) => {
    let script = `<script type="text/javascript">
        var element = document.getElementById(${location});
        var offset =  element.offsetTop;
        window.scrollTo(0, offset)
        element.scrollTop = 5;
        var nameAttr = document.getElementById(${location});
      </script>`;
    return script;
  };

  getFile = () => {
    let htmlContent;
    let url = this.props.url;

    Actions('http_request', {
      url : this.props.url,
      method : 'get',
      data : {}
    })
      .then((res) => {
        htmlContent = res.data;
        this.setState(
          {
            htmlContent: res.data,
            shouldUpdateImgSrc: true,
          },
          () => {
            this.parseHTML(res.data);
          }
        );
      })
      .catch((err) => console.log(err));

    return htmlContent;
  };

  downloadFile = () => {
    Actions('http_request', {
        url : this.props.downloadUrl,
        method : 'get',
        responseType : 'blob'
    }).then(response => {
        console.log("Download Response : ", response)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.props.file_name); //or any other extension
        document.body.appendChild(link);
        link.click();
    }).catch(err => {

    })
   
  }

  switchFullScreen = () => {
    this.setState({
        open: !this.state.open
    })
  }

  renderToolbar = () => {
    return (
      <Paper
        style={{
          width: "100%",
          height: "50px",
          backgroundColor: "#FFFFFF",
          padding: "5px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
        square
        elevation={4}
      >
        {" "}
        <div style = {{flexGrow : 1}}>
          <Tooltip title={this.props.file_name}>
            <Typography
              style={{
                width: "20%",
                flexGrow: 0.9,
              }}
              variant="overline"
              noWrap={true}
            >
              {this.props.file_name}
            </Typography>
          </Tooltip>
        </div>
        <div>
          <IconButton style={{ marginRight : '20px'}} size = 'small' onClick = {this.switchFullScreen}>
              {this.state.open ? <Fullscreen></Fullscreen> : <FullscreenExit></FullscreenExit>}
          </IconButton>
          {
            this.state.download === true && (
                <IconButton 
                    size = 'small'
                    style={{ marginRight : '20px'}}
                    onClick = { (event) => { event.preventDefault(); this.downloadFile()}}
                    // href = {this.props.downloadUrl}
                    // target="_blank"
                    // download = {this.props.filename}
                >
                    <CloudDownload></CloudDownload>
                </IconButton>
            )
          }
        </div>
      </Paper>
    );
  };

  renderFullScreen = () => {
    return (
      <Dialog fullScreen open={this.state.open}>
        {this.renderToolbar()}
        <div style = {{width : '100%', height : 'calc(100% - 50px)'}}>
          <iframe
            title = "KB Document"
            id="iframe-div"
            srcDoc={this.state.htmlContent}
            name={this.props.location}
            width="100%"
            height="100%"
          />
        </div>
      </Dialog>
    )
  }

  render() {
    return (
      <Fragment>
        {this.renderToolbar()}
        <iframe
          title = "KB Document"
          id="iframe-div"
          srcDoc={this.state.htmlContent}
          name={this.props.location}
          width="100%"
          height={parseInt(this.props.height) - 50}
        />
        {this.renderFullScreen()}
      </Fragment>
    );
  }
}

export default HTMLViewer;
